<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Global ASU Forecast</h4>
    <dx-data-grid class="fixGridHeight" id="GlobalASUForecastReportGrid" [dataSource]="globalASUForecastReportData"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false" [columnAutoWidth]="true"
        [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
        <dxi-column dataField="siteId" [visible]="false" caption="Site Id" [width]="120"></dxi-column>
        <dxi-column dataField="productionFacilityId" caption="Facility ID" [width]="120"></dxi-column>
        <dxi-column dataField="lasuRegions" caption="LASU Regions" [width]="120"></dxi-column>
        <dxi-column dataField="countryName" caption="Country" [width]="100"></dxi-column>
        <dxi-column dataField="province" caption="State/Province" [width]="100"></dxi-column>
        <dxi-column dataField="city" [width]="100"></dxi-column>
        <dxi-column dataField="unitOwner" caption="Company/Customer" [width]="200"></dxi-column>
        <dxi-column dataField="awardYear" caption="Est Award Year" [width]="80"></dxi-column>
        <dxi-column dataField="status" [width]="100"></dxi-column>
        <dxi-column dataField="probability" caption="Probability %" [width]="120"></dxi-column>
        <dxi-column dataField="probabilityWeightedOxygen" caption="Probability Weighted Oxygen (tonne/d)" [width]="150">
        </dxi-column>
        <dxi-column dataField="forecastDriver" [width]="150"></dxi-column>
        <dxi-column dataField="forecastDriverCategory" [width]="150"></dxi-column>
        <dxi-column dataField="businessModel" [width]="150"></dxi-column>
        <dxi-column dataField="supplyMode" [width]="150"></dxi-column>
        <dxi-column dataField="notes" [width]="400"></dxi-column>
        <dxi-column dataField="costEstimateMMUSD" caption="Cost Estimate MMUSD" [width]="150"></dxi-column>
        <dxi-column dataField="segmentShort" caption="Segment" [width]="150"></dxi-column>
        <dxi-column dataField="application" [width]="150"></dxi-column>
        <dxi-column dataField="companyType" [width]="150"></dxi-column>
        <dxi-column dataField="oxygenApplication" [width]="150"></dxi-column>
        <dxi-column dataField="liquidOxygen" caption="Liquid Oxygen (sTPD)" [width]="150"></dxi-column>
        <dxi-column dataField="liquidNitrogen" caption="Liquid Nitrogen (sTPD)" [width]="150"></dxi-column>
        <dxi-column dataField="liquidArgon" caption="Liquid Argon (sTPD)" [width]="130"></dxi-column>
        <dxi-column dataField="totalOxygen" caption="Total Oxygen (TPD)" [width]="120"></dxi-column>
        <dxi-column dataField="totalNitrogen" [width]="150"></dxi-column>
        <dxi-column dataField="piggybackvsNonPiggyback" caption="Piggyback vs Non Piggyback" [width]="150"></dxi-column>
        <dxi-column dataField="probabilityWeightedNumberofTrains" caption="Probability Weighted Number Of Trains"
            [width]="150"></dxi-column>
        <dxi-column dataField="avgTrainSize" [width]="150"></dxi-column>
        <dxi-column dataField="trainClass" [width]="100"></dxi-column>
        <dxi-column dataField="o2SizeBrackets" [width]="120"></dxi-column>
        <dxi-column dataField="asuNominalCapacity" caption="ASUNominal Capacity" [width]="120"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>